<header class="navbar navbar-default navbar-fixed-top" id="header-navbar">
    <nav class="header-nav">
        <div class="logo-and-notification-container">
            <a href="" id="logo" class="navbar-brand">
                <img [src]="imageUrl + 'logo-old.png'" alt="" class="normal-logo logo-white">
                <img [src]="imageUrl + 'logo-black.png'" alt="" class="normal-logo logo-black">
                <img [src]="imageUrl + 'logo-small.png'" alt="" class="small-logo hidden-xs hidden-sm hidden">
            </a>
            <div class="nav-no-collapse navbar-left pull-left" style="margin-top: 5px;" *ngIf="showNotificationsIcon">
                <ul class="nav navbar-nav">
                    <li class="dropdown">
                        <a class="btn dropdown-toggle" data-toggle="dropdown" aria-expanded="false"
                            (click)="showNotifications()">
                            <i class="fa fa-bell"></i>
                            <span *ngIf="numberOfNewNotifications > 0"
                                [ngClass]="{'count': numberOfNewNotifications <= 99, 'big-count': numberOfNewNotifications > 99}">{{numberOfNewNotifications}}</span>
                        </a>
                        <ul class="dropdown-menu notifications-list" id="global-notifications-container">
                            <li class="item">
                                <app-user-notifications
                                    height="400px"
                                    width="350px"
                                    [searchObject]="searchObject"
                                    [viewAllFlag]="true"
                                    viewAllMode="navigate"
                                    context="global"
                                    [userNotificationControls]="userNotificationControls"
                                    [(numberOfNewNotifications)]="numberOfNewNotifications"
                                    [showShortNotification]="true"
                                    [notificationClicked]="isNotificationClicked"
                                    (closeCallback)="closeDropdown()"
                                    [jobTypeList]="jobTypeList"
                                    [salaryDurationOptions]="salaryDurationOptions">
                                </app-user-notifications>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <span class="label label-primary header-company-name">
            <span *ngIf="userDetails?.company.companyId === null">(New Company)</span>
            <span [title]="userDetails?.company.companyName" *ngIf="userDetails?.company.companyId !== null">
                {{userDetails?.company.companyName | companyNameFilterPipe}}
                <span *ngIf="userDetails?.company.companyState !== 'Active' && isFourDotFiveUser">({{userDetails?.company.companyStateLabel}})</span>
            </span>
            <sub *ngIf="isFourDotFiveUser" class="switch pointer" (click)="switchCompany()">
                <i class="fas fa-exchange-alt"></i> Switch
            </sub>
        </span>
        <div class="nav-no-collapse pull-right col-sm-4 header-profile-and-logout-container" id="header-nav">
            <button class="navbar-toggle" style="height: inherit; padding: 0px;" id="nav-menu"
                (click)="toggleSideNav()" type="button">
                <span class="sr-only">Toggle navigation</span>
                <span class="fa fa-bars"></span>
            </button>
            <ul class="nav navbar-nav" style="display:flex; flex-wrap: nowrap">
                <li class="dropdown profile-dropdown">
                    <a class="dropdown-toggle" data-toggle="dropdown">
                        <img [src]="imageUrl + 'samples/4dot5-default-no-profile-pic.jpg'">
                        <span class="pointer hidden-xs hidden-sm" [title]="fullName">{{fullName | profileFilterPipe}}</span>
                        <b class="caret" *ngIf="userDetails?.company.companyId !== null && userDetails?.company.companyState !== 'Draft'"></b>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-right"
                        *ngIf="userDetails?.company.companyId !== null && userDetails?.company.companyState !== 'Draft'">
                        <li *ngIf="roleId !== MESSAGECONSTANTS.ROLEIDS.SUPERUSER">
                            <a (click)="showUserProfile(userDetails)" class="cursor-pointer">
                                <i class="fa fa-user"></i>Profile
                            </a>
                        </li>
                        <li>
                            <a (click)="goToChangePassword()" class="cursor-pointer">
                                <i class="fa fa-cog"></i>Change Password
                            </a>
                        </li>
                        <li *ngIf="roleId !== MESSAGECONSTANTS.ROLEIDS.SUPERUSER && roleId !== MESSAGECONSTANTS.ROLEIDS.FOURDOTFIVE_ADMIN">
                            <a (click)="goToNotificationPreferences()" class="cursor-pointer">
                                <i class="fa fa-cog"></i>My Notification Preferences
                            </a>
                        </li>
                        <li class="hidden-xl hidden-lg hidden-md hidden-sm">
                            <a (click)="logout()">
                                <i class="fa fa-power-off"></i>
                                Logout
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="hidden-xxs hidden-xs">
                    <a (click)="logout()"><i class="fa fa-power-off"></i></a>
                </li>
            </ul>
        </div>
    </nav>
</header>

<div *ngIf="userDetails?.company.companyState === 'SoftHold' && !isFourDotFiveUser" class="text-center account-state-banner">
    <span>
        <b>Your account is on Soft Hold. New User and Requisition creation is disabled.</b>
    </span>
</div>

<div *ngIf="!isFourDotFiveUser && userDetails?.plan?.message?.length > 0 && userDetails?.company.companyState !== 'SoftHold'"
    class="text-center account-state-banner">
    <span>
        <b>{{userDetails.plan.message}}</b>
    </span>
</div>
<app-browser-refresh-message></app-browser-refresh-message>
<app-assessments-sync-message></app-assessments-sync-message>
